import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class ChequeIssuedService {
  constructor(private http: HttpUtilService) {}

  ChequeIssuedReport(
    FromDate: string,
    ToDate: string,
  ): Observable<any> {
    return this.http.post(
      "SalesReportService.asmx/ChequeIssuedReport",
      {
        model: {
          FromDate,
          ToDate,
        },
      },
    );
  }
}
